import { getCurrentUser } from "./auth";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
const GRAPHQL_URI = process.env.REACT_APP_GRAPHQL_URI || "/graphql";

async function getAccessToken() {
  return new Promise((resolve, reject) => {
    const user = getCurrentUser();
    if (!user) return reject(new Error("No current user"));

    user.getSession((err, session) => {
      if (err) return reject(err);
      if (!session?.isValid()) return reject(new Error("Session expired"));
      resolve(session.getIdToken().getJwtToken());
    });
  });
}

function buildGraphqlUrl() {
  if (!API_BASE_URL) {
    throw new Error("REACT_APP_API_BASE_URL es obligatorio");
  }
  return `${API_BASE_URL}${GRAPHQL_URI}`;
}

export async function graphqlRequest(query, variables = {}) {
  const token = await getAccessToken();
  const res = await fetch(buildGraphqlUrl(), {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ query, variables }),
  });

  let data;
  try {
    data = await res.json();
  } catch {
    throw new Error(`Respuesta inválida del servidor (HTTP ${res.status})`);
  }

  if (!res.ok) {
    throw new Error(data?.message || data?.error || `HTTP ${res.status}`);
  }
  if (data.errors) throw new Error(JSON.stringify(data.errors));
  return data.data;
}
